
const LocationMap = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Visit Our Office
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our physical office location will be announced shortly
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-white rounded-xl shadow-lg p-12 text-center">
            <div className="w-20 h-20 bg-teal-100 text-teal-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-map-pin-line text-4xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Coming Soon</h3>
            <p className="text-gray-600 text-lg mb-6">
              We're working on establishing our office location in Calgary. 
              Stay tuned for updates on where you can visit us in person.
            </p>
            <p className="text-gray-600">
              In the meantime, feel free to reach out to us via phone or email. 
              We're here to help answer any questions you may have.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationMap;
